import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-resource-not-found',
    templateUrl: './resource-not-found.component.html',
    styleUrls: ['./resource-not-found.component.css'],
    standalone: false
})
export class ResourceNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
